import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { TopNav } from './components/TopNav';
import { MunicipalityProvider } from './hooks/useMunicipality';
import { SidebarProvider } from './hooks/useSidebar';
import { Dashboard } from './pages/Dashboard';
import { Vending } from './pages/Vending';
import { PaymentIntegrations } from './pages/PaymentIntegrations';
import { SmartMeters } from './pages/SmartMeters';
import { LargePowerUsers } from './pages/LargePowerUsers';
import { Vendors } from './pages/Vendors';
import { AddVendor } from './pages/AddVendor';
import { MeterMap } from './pages/MeterMap';
import { Settings } from './pages/Settings';
import { ConsumptionAnalytics } from './pages/ConsumptionAnalytics';
import { FaultDetection } from './pages/FaultDetection';
import { PrepaidRevenue } from './pages/PrepaidRevenue';
import { LpuRevenue } from './pages/LpuRevenue';
import { TariffManagement } from './pages/TariffManagement';
import { BillingIntegrations } from './pages/BillingIntegrations';
import { SubstationMonitoring } from './pages/SubstationMonitoring';
import { OutageDetection } from './pages/OutageDetection';
import { NetworkDiagnostics } from './pages/NetworkDiagnostics';
import { LossAnalytics } from './pages/LossAnalytics';
import { SalesPerformance } from './pages/SalesPerformance';
import { Commissions } from './pages/Commissions';
import { CampaignPrograms } from './pages/CampaignPrograms';
import { CommChannels } from './pages/CommChannels';
import { VendorMap } from './pages/VendorMap';
import { Support } from './pages/Support';
import { Launch } from './pages/Launch';
import { Login } from './pages/Login';
export function App() {
  return <MunicipalityProvider data-id="element-0">
      <SidebarProvider data-id="element-1">
        <div className="flex h-screen bg-gray-50 font-sans overflow-hidden" data-id="element-2">
          <Sidebar data-id="element-3" />
          <div className="flex-1 flex flex-col overflow-hidden" data-id="element-4">
            <TopNav data-id="element-5" />
            <main className="flex-1 overflow-y-auto" data-id="element-6">
              <Routes data-id="element-7">
                <Route path="/" element={<Login data-id="element-9" />} data-id="element-8" />
                <Route path="/dashboard" element={<Dashboard data-id="element-11" />} data-id="element-10" />
                <Route path="/vending" element={<Vending data-id="element-13" />} data-id="element-12" />
                <Route path="/payment-integrations" element={<PaymentIntegrations data-id="element-15" />} data-id="element-14" />

                <Route path="/meters" element={<SmartMeters data-id="element-17" />} data-id="element-16" />
                <Route path="/lpu" element={<LargePowerUsers data-id="element-19" />} data-id="element-18" />
                <Route path="/map" element={<MeterMap data-id="element-21" />} data-id="element-20" />
                <Route path="/consumption-analytics" element={<ConsumptionAnalytics data-id="element-23" />} data-id="element-22" />

                <Route path="/fault-detection" element={<FaultDetection data-id="element-25" />} data-id="element-24" />
                <Route path="/vendors" element={<Vendors data-id="element-27" />} data-id="element-26" />
                <Route path="/vendors/add" element={<AddVendor data-id="element-29" />} data-id="element-28" />
                <Route path="/sales-performance" element={<SalesPerformance data-id="element-31" />} data-id="element-30" />

                <Route path="/commissions" element={<Commissions data-id="element-33" />} data-id="element-32" />
                <Route path="/campaigns" element={<CampaignPrograms data-id="element-35" />} data-id="element-34" />
                <Route path="/comm-channels" element={<CommChannels data-id="element-37" />} data-id="element-36" />
                <Route path="/vendor-map" element={<VendorMap data-id="element-39" />} data-id="element-38" />
                <Route path="/prepaid-revenue" element={<PrepaidRevenue data-id="element-41" />} data-id="element-40" />
                <Route path="/lpu-revenue" element={<LpuRevenue data-id="element-43" />} data-id="element-42" />
                <Route path="/tariff-management" element={<TariffManagement data-id="element-45" />} data-id="element-44" />

                <Route path="/billing-integrations" element={<BillingIntegrations data-id="element-47" />} data-id="element-46" />

                <Route path="/substation-monitoring" element={<SubstationMonitoring data-id="element-49" />} data-id="element-48" />

                <Route path="/outage-detection" element={<OutageDetection data-id="element-51" />} data-id="element-50" />
                <Route path="/network-diagnostics" element={<NetworkDiagnostics data-id="element-53" />} data-id="element-52" />

                <Route path="/loss-analytics" element={<LossAnalytics data-id="element-55" />} data-id="element-54" />
                <Route path="/substation-monitoring" element={<SubstationMonitoring data-id="element-57" />} data-id="element-56" />

                <Route path="/outage-theft-detection" element={<OutageDetection data-id="element-59" />} data-id="element-58" />

                <Route path="/network-diagnostics" element={<NetworkDiagnostics data-id="element-61" />} data-id="element-60" />

                <Route path="/loss-analytics" element={<LossAnalytics data-id="element-63" />} data-id="element-62" />
                <Route path="/settings" element={<Settings data-id="element-65" />} data-id="element-64" />
                <Route path="/support" element={<Support data-id="element-67" />} data-id="element-66" />
                <Route path="/launch" element={<Launch data-id="element-69" />} data-id="element-68" />
                <Route path="/login" element={<Login data-id="element-71" />} data-id="element-70" />
                <Route path="*" element={<Navigate to="/" replace data-id="element-73" />} data-id="element-72" />
              </Routes>
            </main>
          </div>
        </div>
      </SidebarProvider>
    </MunicipalityProvider>;
}